/**
 * @file 请求标识
 * @author wangzhuang
 */

// 获取ip信息
export const GET_IP_INFO = 'GET_IP_INFO';
export const SUBMIT_IP_INFO = 'SUBMIT_IP_INFO';
export const GET_IP_USER_INFO = 'GET_IP_USER_INFO';
export const GET_IP_LIST = 'GET_IP_LIST';
export const GET_IP_DETAIL = 'GET_IP_DETAIL';

// 获取登录
export const GET_USER_INFO = 'GET_USER_INFO';

// 企业认证
export const GET_AUTH = 'GET_AUTH';

// 校验号码
export const GET_CHECK_PHONE = 'GET_CHECK_PHONE';

// 获取认证详情接口
export const GET_GET_DETAIL = 'GET_GET_DETAIL';

// 个人中心列表
export const GET_GET_LIST = 'GET_GET_LIST';
export const GET_PAID_ATTEST_LIST = 'GET_PAID_ATTEST_LIST';

// 获取验证码
export const GET_SEND_CODE = 'GET_SEND_CODE';

// 查询数据
export const GET_V1_SEARCH = 'GET_V1_SEARCH';

// 申诉查询getDetail
export const GET_APPEAL_SEARCH = 'GET_APPEAL_SEARCH';

// 提交申诉
export const GET_APPEAL_SUBMIT = 'GET_APPEAL_SUBMIT';

// 个人申诉
export const GET_APPEAL_PERSON = 'GET_APPEAL_PERSON';

// 企业申诉
export const GET_APPEAL_COMPANY = 'GET_APPEAL_COMPANY';

// 政府申诉
export const GET_APPEAL_GOV = 'GET_APPEAL_GOV';

// 问题反馈
export const GET_CREATE_TOPIC = 'GET_CREATE_TOPIC';

// 黄页号码详情
export const GET_PAGES_DETAIL = 'GET_PAGES_DETAIL';

// 号码标记
export const GET_V1_REPORT = 'GET_V1_REPORT';
export const GET_REPORT_SUBMIT = 'GET_REPORT_SUBMIT';

// 图片验证码
export const GET_V1_CAPTCHA = 'GET_V1_CAPTCHA';

// 申诉详情
export const APPEAL_GET_DETAIL = 'APPEAL_GET_DETAIL';

// 编辑认证详情
export const GET_AUTH_EDIT = 'GET_AUTH_EDIT';

// 编辑申诉详情
export const GET_APPEAL_EDIT = 'GET_APPEAL_EDIT';

// 编辑申诉详情
export const GET_FEEDBACK_DETAIL = 'GET_FEEDBACK_DETAIL';

// 申诉号码列表
export const APPEAL_PHONE_LIST = 'APPEAL_PHONE_LIST';

// 对外询价登录
export const INQUEIRY_LOGIN = 'INQUEIRY_LOGIN';
export const INQUEIRY_LOHOUT = 'INQUEIRY_LOHOUT';

// 直销企业信息提交
export const GET_DELEGATION_AUTH = 'GET_DELEGATION_AUTH';
export const GET_DELEGATION_TYPE = 'GET_DELEGATION_TYPE';
export const GET_DELEGATION_SUBMIT = 'GET_DELEGATION_SUBMIT';

// 获取官方合作伙伴
export const GET_PARTNER_LIST = 'GET_PARTNER_LIST';

// 企业微名片
export const GET_BUSSINESS_CARD = 'GET_BUSSINESS_CARD';
export const SUBMIT_CARD_EVALUATION = 'SUBMIT_CARD_EVALUATION';
export const GET_PZ_CARD = 'GET_PZ_CARD';
export const CHECK_CARD_EVALUATION = 'CHECK_CARD_EVALUATION';

// 企业名称
export const GET_CHECK_COMPANY_NAME = 'GET_CHECK_COMPANY_NAME';

// 获取企业实体
export const GET_ENTITY = 'GET_ENTITY';

// 号码标记申诉
export const APPEAL_UPDATE = 'APPEAL_UPDATE';
export const APPEAL_CLEAN = 'APPEAL_CLEAN';

// 号码质量反馈
export const FEEDBACK_UPDATE = 'FEEDBACK_UPDATE';

// 标记他人号码
export const MARK_UPDATE = 'MARK_UPDATE';
export const MARK_CLEAN = 'MARK_CLEAN';
export const MARK_MSG_UPDATE = 'MARK_MSG_UPDATE';

export const GET_MARK_TYPE = 'GET_MARK_TYPE';

export const GET_MARK_TAG = 'GET_MARK_TAG';

// 认证信息修改
export const VERIFY_MSG_UPDATE = 'VERIFY_MSG_UPDATE';
export const GET_VERIFY_TYPE = 'GET_VERIFY_TYPE';
export const VERIFY_MSG_CLEAN = 'VERIFY_MSG_CLEAN';
// 付费企业详情
export const GET_COMPANY_DETAIL = 'GET_COMPANY_DETAIL';

// 我的认证-卡片&落地页展示数据
export const GET_COMPANY_DATA = 'GET_COMPANY_DATA';
// 评价数
export const GET_ASSESSMENT_STATIC = 'GET_ASSESSMENT_STATIC';

// 核酸检测机构获取用户地域信息
export const UPDATE_LOC_SELECT = 'UPDATE_LOC_SELECT';
export const UPDATE_USER_POSITION = 'UPDATE_USER_POSITION';
export const UPDATE_USER_POINT = 'UPDATE_USER_POINT';

// 核酸地域字典
export const AREA_DICT = 'AREA_DICT';
// 核酸机构列表
export const LOCATION_RESULT = 'LOCATION_RESULT';

// 外部-审核页面
export const GET_DATA_REVIEW_LIST = 'GET_DATA_REVIEW_LIST';
export const GET_DATA_REVIEW_DETAIL = 'GET_DATA_REVIEW_DETAIL';